<template lang="pug">
.input-field(v-if="edit")
        .input
            el-form-item(:label="$t(reaction.__typename)" :size="size")
                el-input-number(
                    v-if="reaction.__typename === 'nextInformation'"
                    type="number"
                    :max="section.informations.length"
                    :min="1"
                    v-model="value"
                    controls-position="right"
                )
                el-input(
                    v-else-if="!['radio', 'select'].includes(reaction.__typename)"
                    type="text"
                    v-model="value"
                )
                .input-wrap.flex-fields(
                    v-else-if="['radio', 'select'].includes(reaction.__typename)"
                )
                    el-input.next-info-value(type="text" v-model="value")
                    .el-input-group.el-input-group--prepend.next-info-next(
                        :title="$t('Go to next insertion')"
                    )
                        .el-input-group__prepend
                            i.el-icon-fa-random.fas
                        el-input-number(
                            type="number"
                            :max="section.informations.length"
                            :min="1"
                            v-model="next"
                            controls-position="right"
                        )
</template>

<i18n>
{
    "en": {
        "text": "Input field",
        "radio": "True/False",
        "select": "Multiple Choice",
        "nextInformation": "Next insertion"
    },
    "de": {
        "text": "Eingabefeld",
        "radio": "Ja/Nein",
        "select": "Mehrfachauswahl",
        "nextInformation": "nächste Einblendung",

        "Go to next insertion": "Gehe zur nächsten Einblendung",

        "Target": "Ziel",
        "Select a targetpage ...": "Zielseite auswählen ...",
        "Email": "E-Mail",
        "Phone number": "Telefonnummer",
        "Internal": "Intern",
        "External": "Extern",
        "Phone": "Telefon",
        "Download": "Download",
        "Open link in new window/tab": "Link in einem neuen Fenster/Tab öffnen"
    }
}
</i18n>

<script>

import _ from 'lodash'

import quillConfig from '@/quill/config'
import store from '@/store'
// import router from '@/router'

// import Treeselect from '@riophae/vue-treeselect'
import InputField from '@/components/Page/Sections/Partials/InputField'

export default{
    name: 'ReactionInputField',
    extends: InputField,
    props: {
        section: {
            type: Object,
            required: true
        },
        reaction: {
            type: Object,
            required: true
        },
    },
    data() {
        // quillConfig.modules.link.pages = this.pages
        return {
            quillConfig
        }
    },
    computed: {
        value: {
            get() {
                return _.get(this.content, 'title', '')
            },
            set(value) {
                // const payload = {
                //     value,
                //     i: this.i,
                //     s: this.s,
                //     c: this.c,
                //     inf: this.inf,
                //     reac: this.reac,
                //     field: 'title'
                // }
                // if (this.inputType == 'Nächste') {
                //     store.commit(`${this.module}/form/evaluationReactionInputFieldValueNextInformation`, payload)
                // }else {
                //     store.commit(`${this.module}/form/evaluationReactionInputFieldValue`, payload)
                // }

                if (this.reaction.__typename === 'nextInformation') {
                    // store.commit(`${this.module}/form/evaluationReactionInputFieldValueNextInformation`, payload)


                    this.$set(this.content, 'title', value);

                    if (!value || typeof Number(value) !== 'number') return false;

                    const nextInformation = this.section.informations.find(el => el.position === Number(value))
                    if (!nextInformation) return false;

                    this.$set(this.content, 'nextInformation', { id: nextInformation.id });
                } else {
                    // store.commit(`${this.module}/form/evaluationReactionInputFieldValue`, payload)
                    this.$set(this.content, 'title', value);
                }
            }
        },
        next: {
            get() {
                if (this.content.nextInformation) {
                    let index = _.findIndex(this.section.informations, ['id', this.content.nextInformation.id])
                    return _.get(this.section.informations[index], 'position')
                }
                return 1
            },
            set(next) {
                // const payload = {
                //     value: this.value,
                //     i: this.i,
                //     s: this.s,
                //     c: this.c,
                //     inf: this.inf,
                //     reac: this.reac,
                //     field: 'title',
                //     next
                // }
                // store.commit(`${this.module}/form/evaluationReactionInputFieldValueAndNextInformation`, payload)

                this.$set(this.content, 'title', this.value);
                this.$set(this.content, 'nextInformation', null);

                if (!next || typeof Number(next) !== 'number') return false;

                const nextInformation = this.section.informations.find(el => el.position === Number(next))

                if (!nextInformation) this.$set(this.content, 'nextInformation', null);
                else this.$set(this.content, 'nextInformation', { id: nextInformation.id });
            }
        },
    }
}

</script>

<style lang="sass" scoped>
.input-wrap.flex-fields
    gap: 0.5rem
    .next-info-next
        width: auto
    &::v-deep
        .el-input-number--medium
            width: 100px
</style>
